/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { ReceiptText } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';

const NS = '/bff/v1/j09-s05-credenciado-consultar-cobranca';

export function ConsultarCobrancaPage() {
  const [estado, setEstado] = useState<any>();
  useEffect(() => {
    void chamarApi<any>(`${NS}/state`, { metodo: 'GET' }).then((resposta) =>
      setEstado(resposta.state),
    );
  }, []);
  if (!estado) return <p role="status">Carregando suas cobranças…</p>;
  return (
    <main className="mx-auto w-full min-w-0 max-w-4xl space-y-5 overflow-x-hidden px-4 py-8">
      <h1 className="text-3xl font-semibold">
        <ReceiptText className="mr-2 inline" />
        {estado.titulo}
      </h1>
      <p>{estado.descricao}</p>
      {estado.vazio && <p>Nenhuma cobrança administrativa disponível.</p>}
      {estado.titulos.map((titulo: any) => (
        <article className="space-y-3 rounded-md border p-4" key={titulo.id}>
          <h2 className="text-xl font-semibold">{titulo.numero}</h2>
          <p>
            Principal R$ {titulo.principal} · Encargos R$ {titulo.encargos_iniciais}
          </p>
          <p className="text-lg font-semibold">
            Saldo R$ {Number(titulo.saldo).toFixed(2)} · {titulo.situacao}
          </p>
          <code className="break-all">Decisão {titulo.decisao_id}</code>
          <h3 className="font-semibold">Histórico financeiro</h3>
          {titulo.movimentos.map((movimento: any) => (
            <div className="border-l-2 pl-3" key={movimento.id}>
              <p>
                {movimento.tipo} · R$ {movimento.valor}
              </p>
              <p className="wrap-break-word">
                {movimento.referencia_bancaria ?? movimento.autorizacao}
              </p>
              {movimento.conciliacao_id && <p>Conciliado</p>}
            </div>
          ))}
        </article>
      ))}
    </main>
  );
}
